import { atom } from 'recoil';
import type { MPSIdentifier } from '../types/mpsTypes';

export const mpsActivationInfoAtom = atom<MPSIdentifier>({
    key: 'mpsActivationInfo',
    default: ((): MPSIdentifier => {
        const searchParams = new URLSearchParams(window.location.search);
        const hasParam = (param: string): boolean => searchParams.has(param);
        const getParamValue = (param: string): string => searchParams.get(param) ?? '';
        return {
            policeNummer: getParamValue('mpsPoliceNummer'),
            isConfirmedToPay: !!hasParam('confirmedToPay'),
            isSourceFromAIA: !!hasParam('sourceFromAIA')
        };
    })()
});
